import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from './Logo';
import ThemeToggle from './ThemeToggle';
import ProfileIcon from './ProfileIcon';
import { useAuth } from '../hooks/useAuth';

function Navbar({ onOpenAuth }) {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  const handleNavClick = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Logo size="sm" withIcon />

        <button
          className="navbar-hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
          <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
          <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
        </button>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <button
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => handleNavClick('/')}
          >
            Home
          </button>
          {isAuthenticated && (
            <button
              className={`nav-link ${isActive('/people') ? 'active' : ''}`}
              onClick={() => handleNavClick('/people')}
            >
              People
            </button>
          )}
        </div>

        <div className={`navbar-actions ${menuOpen ? 'open' : ''}`}>
          <ThemeToggle />
          {isAuthenticated ? (
            <>
              <ProfileIcon />
              <button className="nav-btn nav-btn-outline" onClick={handleLogout}>
                Log Out
              </button>
            </>
          ) : (
            <>
              <button
                className="nav-btn nav-btn-outline"
                onClick={() => { onOpenAuth('login'); setMenuOpen(false); }}
              >
                Log In
              </button>
              <button
                className="nav-btn nav-btn-primary"
                onClick={() => { onOpenAuth('signup'); setMenuOpen(false); }}
              >
                Sign Up
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
